<div class="page">
  <curbnturf-agritourism-header></curbnturf-agritourism-header>
  <section>
    <router-outlet></router-outlet>
  </section>
  <curbnturf-agritourism-footer></curbnturf-agritourism-footer>
</div>
